module.exports = __webpack_public_path__ + "media/images/pic08-fae07370f881e0a23d839f01fd80713a.jpg";